import styled, { keyframes } from 'styled-components';

import Modal from 'components/modal';

const floatUp = keyframes`
  from {
    transform: translateY(30px);
  } to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledModal = styled(Modal)`
  opacity: 0;
  justify-content: space-between;
  align-items: center;
  padding: 1.125rem;
  animation: ${floatUp} 0.5s 0.3s forwards;
  && {
    max-height: 12.5rem;
    top: unset;
    bottom: env(safe-area-inset-bottom);
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6.25rem;
  width: 100%;
  overflow: hidden;
`;

export const Title = styled.p`
  text-transform: uppercase;
  font-weight: ${Styles.fontWeight.heavy};
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.6rem;
`;

export const Address = styled.h1`
  text-transform: uppercase;
  font-weight: ${Styles.fontWeight.normal};
  font-size: 1.25rem;
  font-family: ${Styles.fontFamily.brand};
  margin: 0;
  line-height: 1.8rem;
`;

export const P = styled.p`
  margin: 0;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  margin-left: 1.125rem;
  H1,
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }
`;

export const MapContainer = styled.div`
  height: 6.25rem;
  min-width: 6.25rem;
  border-radius: ${Styles.borderRadius};
  overflow: hidden;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 20rem;
`;
